export default __webpack_public_path__ + "static/media/steer.ead6f0ec.svg";